import { Box, Container, Grid, Link, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Delimiter } from '../../components/delimiter';
import Icon from '../../components/icon';
import HyriaLogo from '../../assets/hyria-logo.svg';
import { H6 } from '../../components/typography';
import { COLORS } from '../../theme';

const Footer = () => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'), {
    noSsr: true
  });
  const isTabletOrLower = useMediaQuery(useTheme().breakpoints.down('md'), {
    noSsr: true
  });

  return (
    <Box sx={{ backgroundColor: COLORS.black }}>
      <Container>
        <Grid
          container
          sx={{
            padding: isMobile ? '70px 40px 30px 40px' : '70px 100px 0px 100px'
          }}
        >
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxHeight: 60
              }}
            >
              <img src={HyriaLogo} alt="Hyria" style={{ height: 32, width: 'auto', filter: 'brightness(0) invert(1)' }} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Box
              sx={{
                display: 'flex',
                padding: '30px 0px 20px 0px',
                justifyContent: isMobile ? 'flex-start' : 'flex-end'
              }}
            >
              <Box
                sx={{
                  padding: '0px 0px',
                  maxHeight: 26
                }}
              >
                <Icon name="facebook" size="xSmall" />
              </Box>
              {/* <Box
                sx={{
                  padding: '0px 25px',
                  maxHeight: 26
                }}
              >
                <Icon name="instagram" />
              </Box> */}
              <Box
                sx={{
                  padding: '0px 0px',
                  maxHeight: 26
                }}
              >
                <Icon name="linkedin" size="xSmall" />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            margin: isMobile ? '0px 40px' : '0px 100px'
          }}
        >
          <Delimiter color={COLORS.white} />
        </Box>

        <Grid
          container
          sx={{
            padding: isMobile ? '40px 40px 0px 40px' : '0px 100px 0px 100px'
          }}
        >
          {isMobile ? null : (
            <Grid item xs={12} md={6} container columnSpacing={1}>
              <Grid item xs={12} lg={12}>
                <H6 color={COLORS.white}>
                  {t('©2023 Hyria. All rights reserved')}
                </H6>
              </Grid>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            md={6}
            container
            justifyContent="flex-end"
            gap={isTabletOrLower ? 0 : 2}
          >
            <Grid item xs={12} md="auto">
              <Link
                href="/Hyria-allmanna%20villkor.docx.pdf"
                target="_blank"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
              >
                <H6
                  sx={
                    (isMobile || isTabletOrLower) && {
                      marginTop: 0 + ' !important',
                      marginBottom: 1 + ' !important'
                    }
                  }
                  color={COLORS.white}
                >
                  {t('User conditions')}
                </H6>
              </Link>
            </Grid>
            <Grid item xs={12} md="auto">
              <Link
                href="/HyriaPersonuppgiftspolicy.docx.pdf"
                target="_blank"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
              >
                <H6
                  sx={
                    (isMobile || isTabletOrLower) && {
                      marginTop: 0 + ' !important',
                      marginBottom: 1 + ' !important'
                    }
                  }
                  color={COLORS.white}
                >
                  {t('Cookie policy')}
                </H6>
              </Link>
            </Grid>
            <Grid item xs={12} md="auto">
              <Link
                href="https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2Fpersonuppgiftpolicy.pdf?alt=media&token=6143d735-22de-4e9c-bccb-62afb496f1ff"
                target="_blank"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
              >
                <H6
                  sx={
                    (isMobile || isTabletOrLower) && {
                      marginTop: 0 + ' !important',
                      marginBottom: 1 + ' !important'
                    }
                  }
                  color={COLORS.white}
                >
                  {t('Privacy policy')}
                </H6>
              </Link>
            </Grid>
          </Grid>

          {isMobile ? (
            <Grid item xs={12} lg={8} xl={8} container columnSpacing={1}>
              <Grid item xs={12} lg={12} xl={12}>
                <H6 color={COLORS.white}>
                  {t('©2023 Hyria. All rights reserved')}
                </H6>
              </Grid>
            </Grid>
          ) : null}
        </Grid>

        <Grid
          container
          sx={{
            padding: isMobile ? '0px 40px 50px 40px' : '0px 100px 20px 100px'
          }}
        >
          <Grid item xs={14} container columnSpacing={1}>
            <Grid item xs={6}>
              <H6
                sx={{
                  mt: 0 + ' !important',
                  mb: 0 + ' !important'
                }}
                color={COLORS.white}
              >
                Drakegatan 10
              </H6>
              <H6
                sx={{
                  mt: 0 + ' !important',
                  mb: 0 + ' !important'
                }}
                color={COLORS.white}
              >
                412 50 Göteborg
              </H6>
              <Link
                href="mailto:info@hyria.se"
                sx={{ color: COLORS.primary, textDecoration: 'none' }}
              >
                info@hyria.se
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
